<template>
  <div class="reportManageList">
    <div class="filters">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" @submit.native.prevent class="form">
          <el-form-item class="mb20" :label="$t('lang.reportExportPro')" prop="project">
            <el-select v-model="ruleForm.project" :placeholder="$t('lang.reportSelectExportPro')">
              <el-option v-for="project in ruleForm.projects" :key="project.id" :value="project.id"
                :label="project.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mb20" :label="$t('lang.reportScreenDate')" required>
            <el-form-item class="dateAll" prop="beginTime">
              <el-date-picker v-model="dateArr" :picker-options="pickerOptions" class="date" type="daterange"
                :range-separator="$t('lang.reportGo')" :start-placeholder="$t('lang.reportBeginDate')" :end-placeholder="$t('lang.reportEndDate')" value-format="timestamp">
              </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="derive('ruleForm')">{{$t('lang.reportExportResult')}}</el-button>
          </el-form-item>
          <el-form-item :label="$t('lang.reportVillage')" prop="villages">
            <el-checkbox-group v-model="ruleForm.villages">
              <el-row>
                <el-col :span="8" v-for="item in ruleForm.gardenList" :key="item.id" :label="item.name" :value="item.id">
                  <el-checkbox :label="item.id">{{item.name}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:reportManageList
   *@Description:报表下载
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-04-14
   */
  import base from '../../../config/base'
  export default {
    data() {
      return {
        // 日期只能选择今天及之前的
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
        dateArr: [], // 开始日期和结束日期
        ruleForm: {
          villages: [], // checkbox选中的小区
          project: '', // 项目id
          projects: this.$i18n.t('lang.reportExportProList.ExportProList'), // 项目列表
          gardenList: [], // 小区列表
          beginTime: '', // 开始日期
          endTime: '', // 结束日期
        },
        rules: {
          project: [{
            required: true,
            message: this.$i18n.t('lang.reportPleaseSelectPro'),
            trigger: 'change'
          }],
          villages: [{
            required: true,
            message: this.$i18n.t('lang.reportPleaseSelectVillage'),
            trigger: 'change'
          }],
          beginTime: [{
            required: true,
            message: this.$i18n.t('lang.reportPleaseSelectDate'),
            trigger: 'change'
          }],
        },
      }
    },
    watch: {
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.ruleForm.beginTime = newVal[0]
          this.ruleForm.endTime = newVal[1]
        } else {
          this.ruleForm.beginTime = ''
          this.ruleForm.endTime = ''
        }
      },
    },
    created() {
      // 调用小区列表方法
      this.gardens()
    },
    methods: {
      // 导出结果方法
      derive(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (navigator.onLine) {
              // 相隔天数
              let apartDay = (this.ruleForm.endTime - this.ruleForm.beginTime) / 86400000
              if (this.ruleForm.beginTime && this.ruleForm.endTime) {
                if (apartDay > 31 || apartDay < -31) {
                  this.$message({
                    type: 'warning',
                    message: this.$i18n.t('lang.reportDateTips'),
                  })
                } else {
                  // 导出报表
                  let url = base.baseUrl + '/tonjiExport?gardenIds=' + this.ruleForm
                    .villages +
                    '&flag=' +
                    this.ruleForm.project + '&startTs=' + this.ruleForm.beginTime + '&endTs=' + this.ruleForm.endTime
                  window.open(url)
                }
              }
            } else {
              this.$message.error(this.$i18n.t('lang.lab_Online'))
            }
          }
        })
      },
      // 获取小区列表数据方法
      gardens() {
        let loading = this.$loading()
        this.$get(`/gardens`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.ruleForm.gardenList = res.list
              console.log(this.ruleForm.gardenList)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    }
  }
</script>

<style scoped>
  .dateAll {
    margin-right: 20px;
    display: inline-block;
  }
  .filters .mb20{
    margin-bottom: 20px;
  }
  .reportManageList .filters .el-card{
    padding: 10px 10px 20px 10px;
  }
</style>